<div id="login" fxLayout="column">
    <div fxLayout="row" class="white-bordered-block">
        <div fxFlex="auto" class="custom-header-content">
            <img
                class="logo5worker"
                src="../assets/images/logos/logo5workerBlue.png"
                alt="logo"
            />
            <span class="blue-text">{{
                'AUTH_PAGE.INTRODUCTION' | translate
            }}</span>
        </div>
        <div fxFlex="150px" class="custom-header-content">
            <mat-icon
                style="margin-right: 10px; cursor: pointer"
                (click)="goToHomePage()"
                >home</mat-icon
            >
            <span style="cursor: pointer" (click)="goToHomePage()">{{
                'AUTH_PAGE.HOME' | translate
            }}</span>
        </div>
        <div>
            <button
                mat-button
                class="language-button"
                [matMenuTriggerFor]="languageMenu"
            >
                <div fxLayout="row" fxLayoutAlign="center center">
                    <img
                        alt="{{ selectedLanguage.id }}"
                        class="flag mr-8"
                        [src]="
                            'assets/icons/flags/' +
                            selectedLanguage.flag +
                            '.png'
                        "
                    />
                    <span class="iso text-uppercase">{{
                        selectedLanguage.id
                    }}</span>
                </div>
            </button>

            <mat-menu #languageMenu="matMenu" [overlapTrigger]="false">
                <button
                    mat-menu-item
                    *ngFor="let lang of languages"
                    (click)="setLanguage(lang)"
                >
                    <span fxLayout="row" fxLayoutAlign="start center">
                        <img
                            class="flag mr-16"
                            [src]="'assets/icons/flags/' + lang.flag + '.png'"
                        />
                        <span class="iso">{{ lang.title }}</span>
                    </span>
                </button>
            </mat-menu>
        </div>
    </div>

    <div
        id="central-content-wrapper"
        fxLayout="row"
        fxLayoutAlign="center center"
    >
        <div *ngIf="loadingIndicator" class="login-spinner">
            <mat-spinner color="accent"></mat-spinner>
        </div>
        <div id="login-form-wrapper" fxLayout="column">
            <div fxLayout="row">
                <button
                    mat-raised-button
                    class="register-button"
                    aria-label="Tạo tài khoản"
                    [routerLink]="'/auth/register'"
                >
                    {{ 'AUTH_PAGE.CREATE_ACCOUNT' | translate }}
                </button>
            </div>
            <div
                id="login-form"
                [@animate]="{
                    value: '*',
                    params: { duration: '300ms', y: '100px' }
                }"
            >
                <div class="title">{{ 'AUTH_PAGE.LOGIN' | translate }}</div>
                <form name="loginForm" [formGroup]="loginForm" novalidate>
                    <mat-form-field appearance="outline">
                        <mat-label>Email</mat-label>
                        <input matInput formControlName="email" />
                        <mat-error
                            *ngIf="loginForm.get('email').hasError('required')"
                        >
                            {{ 'AUTH_PAGE.PLEASE_ENTER_EMAIL' | translate }}
                        </mat-error>
                        <mat-error
                            *ngIf="
                                loginForm.get('email') &&
                                !loginForm.get('email').hasError('required') &&
                                loginForm.get('email').hasError('email')
                            "
                        >
                            {{ 'AUTH_PAGE.INVALID_EMAIL' | translate }}
                        </mat-error>
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>{{'AUTH_PAGE.PASSWORD' | translate}}</mat-label>
                        <input
                            matInput
                            type="password"
                            formControlName="password"
                        />
                        <mat-error> {{ 'AUTH_PAGE.PLEASE_ENTER_PASSWORD' | translate }} </mat-error>
                    </mat-form-field>
                    <mat-error *ngIf="showError && !loadingIndicator">
                        {{ 'AUTH_PAGE.WRONG_USER_NAME_OR_PASSWORD' | translate }}
                    </mat-error>
                    <div
                        class="remember-forgot-password"
                        fxLayout="row"
                        fxLayout.xs="column"
                        fxLayoutAlign="space-between center"
                    >
                        <mat-checkbox
                            class="remember-me"
                            aria-label="Remember Me"
                            formControlName="remember"
                        >
                            {{ 'AUTH_PAGE.REMEMBER_ME' | translate }}
                        </mat-checkbox>
                    </div>

                    <button
                        mat-raised-button
                        color="accent"
                        class="submit-button"
                        aria-label="Đăng nhập"
                        [disabled]="loginForm.invalid || loadingIndicator"
                        (click)="onSubmit(loginForm.value)"
                    >
                        {{ 'AUTH_PAGE.LOGIN' | translate }}
                    </button>
                </form>

                <div
                    class="register"
                    fxLayout="column"
                    fxLayoutAlign="center center"
                >
                    <a
                        class="forgot-password"
                        [routerLink]="'/auth/forgot-password'"
                    >
                        {{ 'AUTH_PAGE.FORGOT_PASSWORD' | translate }}
                    </a>
                </div>
            </div>
        </div>
    </div>
</div>
